import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { fetchMetadata } from '../../../api/MetaTagApi';
import { useLocation, useNavigate } from 'react-router-dom';

const MetaTagsComponent = () => {
    const [metaData, setMetaData] = useState(null);
    const location = useLocation();
    const navigate = useNavigate(); // Initialize navigate
    const liveUrl = "https://unfitmart.com";
    const urlMeta =  window.location.href;

    useEffect(() => {
        const params = new URLSearchParams(location.search);
     
        const fetchMetadataApi = async () => {
            try {
                const metaApi = await fetchMetadata();
                const pathname = location.pathname;               
                // ----------------------- Home -----------------------//
                if (pathname === '/') {
                    setMetaData(metaApi?.Result?.find(item => item.WebPageName === 'Home') || {});
                // ----------------------- Brand Page -----------------------//
                } else if (pathname.includes("brands")) {
                    const matchingItems = metaApi?.Result?.filter(item => {
                        const targetUrl = urlMeta.replace('http://localhost:3000', 'https://stage.unfitmart.com');
                        return item.WebPageURL === liveUrl ? item.WebPageURL === urlMeta : item.WebPageURL === targetUrl;
                    });
                    
                   setMetaData(matchingItems[0] || {})

                //----------------------- Product page ------------------------ //
                } else if (pathname.includes("product")) {
                    const targetUrl = urlMeta.replace('http://localhost:3000', 'https://stage.unfitmart.com');
                    const url = window.location.href;
                    const segments = url.split('/');
                    const productUSIN = segments[4];
                    const matchingItems = metaApi?.Result?.filter(item => item.USIN === productUSIN) || "";                    
                    setMetaData(matchingItems || {});
                }                

                //----------------------- Contact US --------------------------- //
                else if (pathname.includes("contact")) {
                    setMetaData(metaApi?.Result.find(item => item.WebPageName === 'Contact us') || {});

                 //-----------------------  Shipping Policy ----------------------- // 
                }else if(pathname.includes("shipping-policy")) {
                    setMetaData(metaApi?.Result.find(item => item.WebPageName === 'Shipping Policy') || {});

                //------------------------ Terms condition ------------------------- //
                }else if(pathname.includes("terms-condition")) {
                    setMetaData(metaApi?.Result.find(item => item.WebPageName === 'Terms and Conditions') || {});

                //------------------------ Service refund Policy -------------------- //
                }else if(pathname.includes("terms-condition")) {
                    setMetaData(metaApi?.Result.find(item => item.WebPageName === 'Terms and Conditions') || {});

                //------------------------ Privacy Policy --------------------------- //
                }else if(pathname.includes("privacy-policy")) {
                    setMetaData(metaApi?.Result.find(item => item.WebPageName === 'Privacy Policy ') || {});

                //------------------------ Refund Policy ---------------------------- //
                }else if (pathname.includes("refund-policy")) {
                let mainPPData = metaApi?.Result?.find(item => item.WebPageName === "Refund Policy");
                setMetaData(mainPPData || {});

                //------------------------ Category --------------------------------- //
                }else if (pathname.includes("category")) {
                    const matchingItems = metaApi?.Result?.filter(item => {
                        const targetUrl = urlMeta.replace('http://localhost:3000', 'https://stage.unfitmart.com');
                        return item.WebPageURL === liveUrl ? item.WebPageURL === urlMeta : item.WebPageURL === targetUrl;
                    });
                    setMetaData(matchingItems || {});

                } else if (pathname.includes("blogs")) {
                    setMetaData(metaApi?.Result[0] || {});
                } else if (pathname.includes("blog")) {
                    let postId = params.get('post_id');
                    const targetUrl = urlMeta.replace('http://localhost:3000', 'https://unfitmart.com');

                    const matchingItems = metaApi?.Result?.filter(item => {
                        if(item.WebPageURL.includes(targetUrl)){
                            return item.WebPageURL;
                        }
                    });

                    setMetaData(matchingItems[0] || {});
                } else {
                    setMetaData(null);
                }
              
            } catch (error) {
                console.error('Error fetching metadata:', error);
                setMetaData(null); 
            }
        };

        
        fetchMetadataApi();
    }, [location, navigate]); 

     
    if (!metaData) return null;
    let meta;
   
     meta = window.location.href.includes("product") || window.location.href.includes("category") ? metaData?.[0] : metaData;


    const metaTags = {
        title: meta?.MetaTitle || "",
        description: meta?.MetaDescription || "",
        keywords: meta?.MetaKeywords || meta?.MetaTitle,
        'og:title': meta?.MetaTitle || "",
        'og:description': meta?.MetaDescription || "",
        'og:type': window.location.href.includes("product") ? "product" :"website",
        'og:image': window.location.href.includes("product") ? meta?.OgImage : "https://unfitmart.com/static/media/logo_orange.bb16279f743d1e222a18998f34a21d9d.svg",
        'og:url': meta?.MetaUrl || window.location.href
    };
    return (
        <Helmet>
            <title>{metaTags.title}</title>
            <meta name="description" content={metaTags.description} />
            <meta name="keywords" content={metaTags.keywords} />
            <meta property="og:locale" content="en_in"/>
            <meta property="og:title" content={metaTags['og:title']} />
            <meta property="og:description" content={metaTags['og:description']} />
            <meta property="og:image" content={metaTags['og:image']} />
            <meta property="og:image:secure_url" content={metaTags['og:image']}/>
            <meta property="og:image:type" content="image/png"/>
            <meta property="og:image:width" content="370"/>
            <meta property="og:image:height" content="462"/>
            <meta property="og:type" content={metaTags['og:type']} />
            <meta property="og:url" content={metaTags['og:url']} />
            <meta property="og:site_name" content="Unfitmart" />
            <meta property="og:email" content="support@unfitmart.com" />
            <meta property="og:phone_number" content="1800 202 5157" />
            <meta property="og:latitude" content="23.014509"/>
            <meta property="og:longitude" content="72.591759"/>
            <meta property="og:street-address" content="Isquare Corporate Park, 1114-1116, Science City, Panchamrut Bunglows II, Sola"/>
            <meta property="og:locality" content="Ahmedabad"/>
            <meta property="og:region" content="Gujarat"/>
            <meta property="og:postal-code" content="380060"/>
            <meta property="og:country-name" content="IN"/>
            <link rel="canonical" href={`${window.location.href}`} />
            {/* Add any other meta tags here */}
        </Helmet>
    );
};

export default MetaTagsComponent;
